
const  baseUrl='https://backend.asyv.ac.rw/api';//for server
//const  baseUrl='http://localhost:8000/api';//for local computer


export default baseUrl;